import type { GalleryCardType } from "@volgo/core/contract";
import { createContext, type ReactNode, useContext, useEffect, useRef, useState } from "react";

const Context = createContext<{
  items: readonly GalleryCardType[];
  setItems: (items: readonly GalleryCardType[]) => void;
  visited: Set<string>;
}>({ items: [], setItems: () => {}, visited: new Set() });
export function GallerySourceProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<readonly GalleryCardType[]>([]);
  const visited = useRef(new Set<string>());
  return (
    <Context.Provider value={{ items, setItems, visited: visited.current }}>{children}</Context.Provider>
  );
}
export function useGallerySource(items: readonly GalleryCardType[]) {
  const { setItems } = useContext(Context);
  useEffect(() => {
    setItems(items);
    return () => setItems([]);
  }, [items, setItems]);
}
export function useGalleryItems() {
  return useContext(Context).items;
}
export function useGalleryVisits() {
  return useContext(Context).visited;
}
